import { appLinks } from "../assets/constants/Strings";
import { Dictionary, ExperienceId, IExperienceContent } from "../types";

export const previousButtonTitle = "Previous";
export const nextButtonTitle = "Next";
export const experienceContent = {
    [ExperienceId.Placeholder]: {
    role: "Placeholder Role",
    stackArea: "Placeholder stack area",
    company: "Placeholdr companyy",
    projectList: [
      {
        title: "Project title",
        technologies:
          "Project technologies",
        links: [{ href: "www.google.com", linkTitle: "Link sitee" }],
      }
    ],
    prevId: undefined,
    nextId: undefined,
    },
    [ExperienceId.Consulting]: {
    role: "Technical Consultant, Data Analyst, Automation Engineer",
    stackArea: "",
    company: "",
    projectList: [
      {
        title: "Green City Tax - Data Analytics and Marketing",
        technologies:
          "Technologies used: Google Sheets, MIcrosoft Word, Twilio, Quickbooks, ATOM",
        links: [
          { href: undefined, linkTitle: "Aggregated client data over multiple years, cleaned data, created data visuals, and authored report of insights on target market customers" },
          { href: undefined, linkTitle: "Created foundational client marketing materials through data analysis of internal data and market research using internal data tools/platforms" },
        ],
      },
      {
        title: "Snaggletooth Studios - Automation Software Engineer",
        technologies:
          "Technologies used: Google Workspace, Google Cloud, Google Sheets, App Scripts, JavaScript, N8N",
        links: [
          { href: undefined, linkTitle: "Improved employee intake process by 90% through software automation and optimizations using Google Cloud, Google App Scripts and Javascript" },
          { href: undefined, linkTitle: "Increased client engagement via email though software automations and optimizations for client marketing flows using using Google Cloud, Google App Scripts, Google Sheets, and JavaScript" },
          { href: undefined, linkTitle: "Increased maintainability and readability by 70% by implementing JSDoc style documentation throughout codebase" },
          { href: undefined, linkTitle: "Made it possible to create further custom workflow automations by researching and deploying a custom N8N application instance" },
        ],
      }
    ],
    prevId: ExperienceId.CitrusHighAltitudeBalloon,
    nextId: ExperienceId.OKCupid,
    },
    [ExperienceId.OKCupid]: {
    role: "Data Analyst",
    stackArea: "",
    company: "OKCupid Case Study",
    projectList: [
      {
        title: "Dating Profile Analysis and Insights",
        technologies:
          "Technologies used: Python, Excel, Kaggle, Github",
        links: [
          { href: "https://www.kaggle.com/code/andrearaylopez/okcupid-case-study", linkTitle: "Kaggle" },
          { href: undefined, linkTitle: "🚧 Note: Complete article coming soon!" },
        
        ],
      }
    ],
    prevId: ExperienceId.Consulting,
    nextId: ExperienceId.HboMax,
  },
  [ExperienceId.HboMax]: {
    role: "Software Engineer, Lead",
    stackArea: "Frontend Web and Mobile Applications",
    company: "Warner Brothers Discovery",
    projectList: [
      {
        title: "Max | Streaming Entertainment Web Application",
        technologies:
          "Technologies used: React, JavaScript, Typescript, Storybook",
        links: [{ href: appLinks.maxWebsite, linkTitle: "Max Site" }],
      },
      {
        title:
          "HBO Max | Streaming Entertainment Web and Mobile (iOS/android) Applications",
        technologies: "Technologies used: React Native, JavaScript, Typescript",
      },
    ],
    prevId: ExperienceId.Consulting,
    nextId: ExperienceId.Isbx,
  },
  [ExperienceId.Isbx]: {
    role: "Software Developer",
    stackArea: "Full Stack Mobile and Web Applications",
    company: "ISBX Corporation",
    projectList: [
      {
        title: "RedBull CoPilot | Internal Event Management Mobile Application",
        technologies:
          "Technologies used: React, React Native, JavaScript, Typescript, Redux, Node.js, Express, MongoDB, Firebase",
        links: [
          {
            href: appLinks.isbxRedbullCaseStudy,
            linkTitle: "Company listing",
          },
        ],
        additionalDescription: "Mobile app redesign rebuild",
      },
      {
        title: "Puffco | Bluetooth Vaporizer Mobile Application",
        technologies:
          "Technologies used: React Native, Typescript, NestJS, typeORM",
        links: [
          {
            href: appLinks.puffcoYoutubePromo,
            linkTitle: "Youtube promo",
          },
          {
            href: appLinks.puffcoIsbxCaseStudy,
            linkTitle: "Company listing",
          },
        ],
        additionalDescription: "Mobile app launch and maintenance",
      },
      {
        title: "Rapid Credit | Credit Management Mobile Application",
        technologies: "Technologies used: Expo, React Native, Typescript",
        links: [
          {
            href: appLinks.rapidCreditAppstore,
            linkTitle: "App store listing",
          },
        ],
        additionalDescription: "Mobile app redesign rebuild",
      },
      {
        title: "HED Unity | Bluetooth Headphone Mobile Application",
        technologies: "Technologies used: Swift, RxSwift",
        additionalDescription:
          "Mobile app redesign rebuild, API integration with well-known music streaming providers",
      },
    ],
    prevId: ExperienceId.HboMax,
    nextId: ExperienceId.Intel,
  },
  [ExperienceId.Intel]: {
    role: "Graduate Software Engineer Intern",
    stackArea: "Frontend Web Applications",
    company: "Intel Corporation",
    projectList: [
      {
        title:
          "Created a proof of concept software tool that checked if servers, databases, APIs, inter-process communication framework tools, websites, and windows applications were fully functional after a monthly system patch, and reboot using C# and .NET Framework",
      },
      {
        title:
          "Researched, developed, and implemented methods for optimally displaying product manufacturing flow charts on internal websites to be adopted by 60+ users using Wiki Enterprise, HTML, and CSS",
      },
      {
        title:
          "Researched methods for inserting data tables with dynamic attributes into databases using SQL Server Integration Services and SQL Server Management Services",
      },
    ],
    prevId: ExperienceId.Isbx,
    nextId: ExperienceId.CalPoly,
  },
  [ExperienceId.CalPoly]: {
    role: "Embedded Engineer Intern",
    stackArea: "Embedded Systems",
    company: "Cal Poly Pomona CS Dept.",
    projectList: [
      {
        title:
          "Created a smart pet door prototype that was a cost-effective substitution to existing pet doors, with mobile and intelligent capabilities.",
        technologies:
          "Technologies used: Raspberry Pi 2, Arduino, Bluetooth beacon, linear servo motor",
      },
    ],
    prevId: ExperienceId.Intel,
    nextId: ExperienceId.IosBdayPal,
  },
  [ExperienceId.IosBdayPal]: {
    role: "iOS Engineer",
    stackArea: "Mobile Applications",
    company: "Andrea Lopez",
    projectList: [
      {
        title:
          "Created an iOS birthday mobile application that lets you organize your birthdays by friends and groups.",
        additionalDescription:
          "Features: import from contacts, notifications, customizable theme colors, and CoreData solution in",
        technologies:
          "Technologies used: Swift, CoreData, AppStoreConnect, Testflight, Sketch ",
        links: [
          {
            href: appLinks.bdayPalPromoWebsite,
            linkTitle: "BdayPal promo website",
          },
          {
            href: appLinks.bdayPalAppstore,
            linkTitle: "Appstore listing",
          }
        ],
      },
      {
        title: "🚧 Note: This app is now retired and is no longer available as of Oct 2025. It had a 7 year long run and provided me tremendous value. I will update this page soon with more."
      }
    ],
    prevId: ExperienceId.CalPoly,
    nextId: ExperienceId.WebStyledResume,
  },
  [ExperienceId.WebStyledResume]: {
    role: "Web Engineer",
    stackArea: "Web Applications",
    company: "Andrea Lopez",
    projectList: [
      {
        title: "Web Styled Resume",
        technologies: "Technologies used: Jekyll, JS, CSS, HTML",
        links: [
          {
            href: appLinks.styledResumeAndreaLopezDev,
            linkTitle: "styledresume",
          },
        ],
      },
      {
        title: "PDF Resume",
        links: [
          { href: appLinks.resumeAndreaLopezDev, linkTitle: "resume" },
        ],
      },
    ],
    prevId: ExperienceId.IosBdayPal,
    nextId: ExperienceId.FpgaDigitImageRecognition,
  },
  [ExperienceId.FpgaDigitImageRecognition]: {
    role: "Embedded Engineer Student",
    stackArea: "Embedded Applications",
    company: "UCDavis Student Design Team",
    projectList: [
      {
        title:
          "Created an application specific processor that could recognize and classify handwritten digits using a field programmable gate array (FPGA).",
        technologies:
          "Technologies used: Cyclone V Altera FPGA, Quartus II, Github, MATLAB, C, Verilog",
        links: [
          {
            href: appLinks.fpgaDigitImageRecognitionWordpress,
            linkTitle: "Team project Wordpress blog",
          },
        ],
      },
    ],
    prevId: ExperienceId.WebStyledResume,
    nextId: ExperienceId.UcdInfinityMirror,
  },
  [ExperienceId.UcdInfinityMirror]: {
    role: "Embedded Engineer Student",
    stackArea: "Technologies used: Embedded Applications",
    company: "UC Davis EEEmerge Team",
    projectList: [
      {
        title:
          "Created a 2 ft. x 2 ft. infinity mirror, which was activated by hand proximity sensors.",
        technologies: "TI micro-controller, Code Composer Studio, C/C++.",
      },
    ],
    prevId: ExperienceId.FpgaDigitImageRecognition,
    nextId: ExperienceId.CitrusHighAltitudeBalloon,
  },
  [ExperienceId.CitrusHighAltitudeBalloon]: {
    role: "Embedded Engineer Student",
    stackArea: "Technologies used: Embedded Applications",
    company: "Citus College High Altitude Balloon Team",
    projectList: [
      {
        title:
          "Researched and conducted experiments relating to the cosmos and atmosphere.",
        technologies: "Arduino, Altimeter, Geiger counter, Recorder.",
        links: [
          {
            href: appLinks.arduinoCitrusHABFacebook,
            linkTitle: "High Altitude Balloon Team Facebook",
          },
        ],
      },
    ],
    prevId: ExperienceId.UcdInfinityMirror,
    nextId: ExperienceId.Consulting,
  },
} as Dictionary<ExperienceId, IExperienceContent>;

export const getExperienceContent = (experienceId: string) => {
  switch (experienceId) {
    case ExperienceId.OKCupid:
      return experienceContent[ExperienceId.OKCupid];
    case ExperienceId.Consulting:
      return experienceContent[ExperienceId.Consulting];
    case ExperienceId.HboMax:
      return experienceContent[ExperienceId.HboMax];
    case ExperienceId.Isbx:
      return experienceContent[ExperienceId.Isbx];
    case ExperienceId.Intel:
      return experienceContent[ExperienceId.Intel];
    case ExperienceId.CalPoly:
      return experienceContent[ExperienceId.CalPoly];
    case ExperienceId.IosBdayPal:
      return experienceContent[ExperienceId.IosBdayPal];
    case ExperienceId.WebStyledResume:
      return experienceContent[ExperienceId.WebStyledResume];
    case ExperienceId.FpgaDigitImageRecognition:
      return experienceContent[ExperienceId.FpgaDigitImageRecognition];
    case ExperienceId.UcdInfinityMirror:
      return experienceContent[ExperienceId.UcdInfinityMirror];
    case ExperienceId.CitrusHighAltitudeBalloon:
      return experienceContent[ExperienceId.CitrusHighAltitudeBalloon];
    case ExperienceId.Placeholder:
      return experienceContent[ExperienceId.CitrusHighAltitudeBalloon];
    default:
      return undefined;
  }
};